import { Input } from 'antd';
import React from 'react';
import HSButton from '../../../common/Button';

type Props = {
    setReferralCode: (value: string) => void;
    onEnterReferralCode: () => void;
    referralCode: string;
};

const ReferralFirstBlock: React.FC<Props> = ({ setReferralCode, onEnterReferralCode, referralCode }) => {
    const title = 'Were you recommended by a friend?';

    return (
        <>
            <div className="w-full ">
                <div className="w-full">
                    <div className=" pt-4 md:pt-20">
                        <div className="bg-[#13223E] box-border p-4 md:py-12 md:px-20 h-auto md:flex md:items-center w-full">
                            <div className="w-full md:w-1/2">
                                <p className="text-white text-left md:w-3/4 h-auto text-xl md:text-2xl font-[WorkSans-Semibold] font-semibold">
                                    {title}
                                </p>
                                <p className="font-[WorkSans] text-[#EAEAEA] text-base md:text-lg pb-8 md:p-0 text-left">
                                    Enter referral code and your friend will receive $500
                                </p>
                            </div>
                            <div className="md:w-1/2 md:justify-end md:pl-4">
                                <Input
                                    className={`h-12 rounded box-border`}
                                    placeholder={'Enter referral code'}
                                    value={referralCode}
                                    onKeyPress={(event) => {
                                        if (event.key === 'Enter') {
                                            onEnterReferralCode();
                                        }
                                    }}
                                    type={'text'}
                                    onChange={(e) => setReferralCode(e.target.value)}
                                    suffix={
                                        <>
                                            <HSButton
                                                transparent={true}
                                                title="Submit"
                                                isArrow={true}
                                                className={`SourceSansPro-SemiBold uppercase h-10 min-h-full pl-8 pr-4 flex justify-center items-center`}
                                                onClick={onEnterReferralCode}
                                            />
                                        </>
                                    }
                                />
                            </div>
                            {/* <div className="block md:hidden w-full">
                                <Input
                                    className={`referral_code_contain_input w-full h-12 rounded box-border`}
                                    placeholder={'Enter referral code'}
                                    value={referralCode}
                                    onKeyPress={(event) => {
                                        if (event.key === 'Enter') {
                                            onEnterReferralCode();
                                        }
                                    }}
                                    type={'text'}
                                    onChange={(e) => setReferralCode(e.target.value)}
                                />
                                <div className='py-4 flex justify-center items-center'>
                                    <HSButton
                                        title='Submit'
                                        isArrow={true}
                                        className={`SourceSansPro-SemiBold uppercase h-10 min-h-full pl-8 pr-4 flex justify-center items-center`}
                                        onClick={onEnterReferralCode}
                                    />
                                </div>

                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReferralFirstBlock;
